import * as React from 'react';

import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { Person } from '../../../../store/details/case/model';
import { StaticInformation } from '../../../custom/static-information';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './person.module.css';

interface PersonProps {
  readonly person: Person;
  readonly header: string;
}

class PersonComponent extends React.Component<PersonProps> {
  private localization: Ii18n;

  constructor(props: PersonProps) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    const numberOfElements = Object.values(this.props.person).filter(x => x && x !== 'Unknown').length;
    if (numberOfElements === 0) {
      return null;
    }

    return (
      <div className={styles.container}>
        <h2>{this.localization.get(this.props.header)}</h2>
        <div className={styles.static}>
          <div className={styles.staticContent}>
            <StaticInformation
              translation='details.person'
              headerText=''
              information={{
                'firstName': this.props.person.firstName,
                'lastName': this.props.person.lastName,
                'street': this.props.person.street,
                'buildingNumber': this.props.person.buildingNumber,
                'busNumber': this.props.person.busNumber,
                'city': this.props.person.city,
                'country': this.props.person.country,
                'telephone': this.props.person.telephone,
                'telephoneWork': this.props.person.telephoneWork,
                'mobile': this.props.person.mobile,
                'fax': this.props.person.fax,
                'email': this.props.person.email,
                'language': this.props.person.language
              }} />
          </div>
        </div>
      </div>
    );
  }
}

export { PersonComponent };
